








































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import ClientConfig from '@/clients/entities/client-config'

@Component
export default class ClientConfigsTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  private loading!: boolean

  @Prop({ default: () => [] })
  private configs!: ClientConfig[]

  private get headers() {
    return [
      {
        text: this.$t('clients.models.client-config.name'),
        value: 'name',
        sortable: false,
      },
      {
        text: this.$t('clients.models.client-config.clientId'),
        value: 'clientId',
        sortable: false,
      },
      {
        text: this.$t('clients.models.client-config.connectionString'),
        value: 'connectionString',
        sortable: false,
      },
      {
        text: this.$t('clients.models.client-config.notificationHubPath'),
        value: 'notificationHubPath',
        sortable: false,
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        class: 'td-w-shrink',
        align: 'end',
      },
    ]
  }

  private send(config: ClientConfig) {
    this.$emit('send', config)
  }

  private edit(config: ClientConfig) {
    this.$emit('edit', config)
  }

  private remove(config: ClientConfig) {
    if (
      confirm(
        this.$tc('clients.components.client-configs-table.confirm_remove')
      )
    ) {
      this.$emit('remove', config)
    }
  }

  private refresh(config: ClientConfig) {
    if (confirm('Wollen Sie jetzt auf Firebase v1 migrieren?')) {
      this.$emit('migrate', config)
    }
  }

  private getConnectionStringText(connectionString: string) {
    const regx = /Endpoint=([^;]*);/
    const match = connectionString.match(regx)
    if (match && match.length >= 1) {
      return match[1]
    }
    return ''
  }
}
